import LearnerDashboardBadges from '../components/achievements/badges/LearnerDashboardBadges';
import LearnerDashboardCertificates from '../components/achievements/certificates/LearnerDashboardCertificates';
import { Stack } from '@chakra-ui/react';
import { useAuthStore } from '@/client/services/state/authStore';

export default function LearnerDashboardAchievements() {
  const { authConfig } = useAuthStore();
  const { company } = authConfig;
  const {
    feature_flags: { enable_badges: enableBadges },
  } = company;

  return (
    <Stack spacing={8}>
      {enableBadges && <LearnerDashboardBadges />}

      <LearnerDashboardCertificates />
    </Stack>
  );
}
